import { Component, OnInit, Input, OnChanges, EventEmitter, Output } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { LgvSettingsService, LgvUserService } from '../../core/core.module';
import { LgvModel } from '../../data-models/longevity.model';

@Component({
    selector: 'lgv-expander',
    templateUrl: 'lgv-expander.component.html',
    styleUrls: ['lgv-expander.component.scss']
})

export class LgvExpander implements OnInit, OnChanges{

    AgentDTO$: Observable<LgvModel.AgentDTO>;

    @Input() ExpanderID: string;
    @Input() IsValid: boolean = true;
    @Input() IsExpanded: boolean = false;
    @Output() IsExpandedChange = new EventEmitter<boolean>();
    @Output() ExpanderOpened = new EventEmitter<string>();

    //LgvExpPanelOpen: boolean = false;

    constructor(
        public LgvUserSvc: LgvUserService,
        public SendEmailDialog: MatDialog,
        public LgvSettingsService: LgvSettingsService) { }

    ngOnInit() {
        //console.log('ExpanderID: ' + this.ExpanderID);
    }

    ngOnChanges() {
        //console.log(`*** Detected Changes ***`);
        //console.log('IsExpanded is ' + (this.IsExpanded ? 'Expanded ' : 'NOT Expanded')  + ' | '  + this.ExpanderID );

        //this.LgvExpPanelOpen = this.IsExpanded;
    }

    OnExpansionChange(isExp: boolean) {
        //console.log('OnExpansionChange: ' + isExp + ' |  ID: ' + this.ExpanderID);
        //this.IsExpanded = isExp;
        this.IsExpandedChange.emit(isExp);

        if (isExp) {
            this.ExpanderOpened.emit(this.ExpanderID);
        }
    }
}
